import React, { useState, useEffect, useRef, useContext } from "react";
import UiTopRightSection from "./UiTopRightSection";
import { UiProfileInfo } from "../../../../pages/auth/view/UiProfileInfo";
import { Context } from "../../../../../_context/Store";

export default function UiTopNavProfile(props) {
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [state, dispatch] = useContext(Context);

    const newRef = useRef(null);
    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    });

    const handleOutsideClick = (e) => {
        if (newRef.current && !newRef.current.contains(e.target)) {
            dispatch({
                type: "SHOW_PROFILE_MENU",
                payload: false,
            });
        }
    };

    const showProfile = () => {
        dispatch({
            type: "SHOW_PROFILE_MENU",
            payload: true,
        });
    };

    const closeProfile = () => {
        dispatch({
            type: "SHOW_PROFILE_MENU",
            payload: false,
        });
    };

    return (
        <>
            <div className="sb-top-nav-wr__profile-area">
                <UiTopRightSection showProfile={showProfile} />
                <div
                    className={
                        state.show_profile_menu
                            ? "sb-top-nav-wr__profile-expanded show-profile-div"
                            : "sb-top-nav-wr__profile-expanded"
                    }
                    ref={newRef}
                >
                    <UiProfileInfo
                        closeProfile={closeProfile}
                        show={state.show_profile_menu}
                    />
                </div>
            </div>
        </>
    );
}
